import React from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'

export interface TimesheetReportTableDataRow {
  name: string
  coreHours: Array<number>
  realHours: Array<number>
  percentage: Array<number>
}

export interface TimesheetReportTableProps {
  realHourColumn: string
  rows?: Array<TimesheetReportTableDataRow>
}

function getCellColour(percentage: number): string {
  if (percentage < 100.0) {
    return '#F28C28' // Cadmium Orange
  }
  return '#50C878' // Emerald Green
}

function floorAfter(number: number, dp: number): string {
  const factor = 10.0 ** dp
  return (Math.floor(number * factor) / factor).toString()
}

export function TimesheetReportTable({ realHourColumn, rows }: TimesheetReportTableProps) {
  return (
    <TableContainer>
      <Table sx={{ minWidth: 650 }} aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ borderBottomWidth: 0 }}></TableCell>
            <TableCell colSpan={3} sx={{ borderLeft: '2px solid black', borderBottomWidth: 0 }} align="center">
              Q1 Total
            </TableCell>
            <TableCell colSpan={3} sx={{ borderLeft: '2px solid black', borderBottomWidth: 0 }} align="center">
              Q2 Total
            </TableCell>
            <TableCell colSpan={3} sx={{ borderLeft: '2px solid black', borderBottomWidth: 0 }} align="center">
              Q3 Total
            </TableCell>
            <TableCell colSpan={3} sx={{ borderLeft: '2px solid black', borderBottomWidth: 0 }} align="center">
              Q4 Total
            </TableCell>
            <TableCell colSpan={3} sx={{ borderLeft: '2px solid black', borderBottomWidth: 0 }} align="center">
              Annual Total
            </TableCell>
          </TableRow>
          <TableRow sx={{ borderBottom: '2px solid black' }}>
            <TableCell>Name</TableCell>
            <TableCell align="center" sx={{ borderLeft: '2px solid black' }}>
              Core
            </TableCell>
            <TableCell align="center">{realHourColumn}</TableCell>
            <TableCell align="center">%</TableCell>
            <TableCell align="center" sx={{ borderLeft: '2px solid black' }}>
              Core
            </TableCell>
            <TableCell align="center">{realHourColumn}</TableCell>
            <TableCell align="center">%</TableCell>
            <TableCell align="center" sx={{ borderLeft: '2px solid black' }}>
              Core
            </TableCell>
            <TableCell align="center">{realHourColumn}</TableCell>
            <TableCell align="center">%</TableCell>
            <TableCell align="center" sx={{ borderLeft: '2px solid black' }}>
              Core
            </TableCell>
            <TableCell align="center">{realHourColumn}</TableCell>
            <TableCell align="center">%</TableCell>
            <TableCell align="center" sx={{ borderLeft: '2px solid black' }}>
              Core
            </TableCell>
            <TableCell align="center">{realHourColumn}</TableCell>
            <TableCell align="center">%</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(rows ?? []).map(row => (
            <TableRow key={row.name}>
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="center" sx={{ borderLeft: '2px solid black' }}>
                {row.coreHours[0]}
              </TableCell>
              <TableCell align="center" sx={{ color: getCellColour(row.percentage[0]) }}>
                {floorAfter(row.realHours[0], 1)}
              </TableCell>
              <TableCell align="center">{row.percentage[0]}</TableCell>
              <TableCell align="center" sx={{ borderLeft: '2px solid black' }}>
                {row.coreHours[1]}
              </TableCell>
              <TableCell align="center" sx={{ color: getCellColour(row.percentage[1]) }}>
                {floorAfter(row.realHours[1], 1)}
              </TableCell>
              <TableCell align="center">{row.percentage[1]}</TableCell>
              <TableCell align="center" sx={{ borderLeft: '2px solid black' }}>
                {row.coreHours[2]}
              </TableCell>
              <TableCell align="center" sx={{ color: getCellColour(row.percentage[2]) }}>
                {floorAfter(row.realHours[2], 1)}
              </TableCell>
              <TableCell align="center">{row.percentage[2]}</TableCell>
              <TableCell align="center" sx={{ borderLeft: '2px solid black' }}>
                {row.coreHours[3]}
              </TableCell>
              <TableCell align="center" sx={{ color: getCellColour(row.percentage[3]) }}>
                {floorAfter(row.realHours[3], 1)}
              </TableCell>
              <TableCell align="center">{row.percentage[3]}</TableCell>
              <TableCell align="center" sx={{ borderLeft: '2px solid black' }}>
                {row.coreHours[4]}
              </TableCell>
              <TableCell align="center" sx={{ color: getCellColour(row.percentage[4]) }}>
                {floorAfter(row.realHours[4], 1)}
              </TableCell>
              <TableCell align="center">{row.percentage[4]}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
